import script from "./WorkflowDetailsStreamsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowDetailsStreamsSection.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowDetailsStreamsSection.vue?vue&type=style&index=0&id=afd45f7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afd45f7c"]])

export default __exports__